import { Spinner } from '@fluentui/react';
import React from 'react';
import type { ISpinnerProps } from '@fluentui/react/lib/components/Spinner/Spinner.types';

const Loading: React.FC<ISpinnerProps & { isBlack?: boolean }> = ({ isBlack, ...props }) => {
  return (
    <Spinner
      label='loading...'
      size={3}
      styles={{
        label: { color: isBlack ? '#999' : '#f7f7f7' },
        circle: {
          borderColor: isBlack ? '#000 #999 #999 #999' : '#fff #ccc #ccc #ccc',
          borderWidth: 3
        }
      }}
      {...props}
    />
  );
};
export default Loading;
